import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { withAlg as invalidKeyInput } from './invalid_key_input.js';
import isKeyLike, { types } from '../runtime/is_key_like.js';
var symmetricTypeCheck = function symmetricTypeCheck(alg, key) {
  if (key instanceof Uint8Array) return;
  if (!isKeyLike(key)) {
    throw new TypeError(invalidKeyInput.apply(void 0, [alg, key].concat(_toConsumableArray(types), ['Uint8Array'])));
  }
  if (key.type !== 'secret') {
    throw new TypeError("".concat(types.join(' or '), " instances for symmetric algorithms must be of type \"secret\""));
  }
};
var asymmetricTypeCheck = function asymmetricTypeCheck(alg, key, usage) {
  if (!isKeyLike(key)) {
    throw new TypeError(invalidKeyInput.apply(void 0, [alg, key].concat(_toConsumableArray(types))));
  }
  if (key.type === 'secret') {
    throw new TypeError("".concat(types.join(' or '), " instances for asymmetric algorithms must not be of type \"secret\""));
  }
  if (usage === 'sign' && key.type === 'public') {
    throw new TypeError("".concat(types.join(' or '), " instances for asymmetric algorithm signing must be of type \"private\""));
  }
  if (usage === 'decrypt' && key.type === 'public') {
    throw new TypeError("".concat(types.join(' or '), " instances for asymmetric algorithm decryption must be of type \"private\""));
  }
  if (key.algorithm && usage === 'verify' && key.type === 'private') {
    throw new TypeError("".concat(types.join(' or '), " instances for asymmetric algorithm verifying must be of type \"public\""));
  }
  if (key.algorithm && usage === 'encrypt' && key.type === 'private') {
    throw new TypeError("".concat(types.join(' or '), " instances for asymmetric algorithm encryption must be of type \"public\""));
  }
};
var checkKeyType = function checkKeyType(alg, key, usage) {
  var symmetric = alg.startsWith('HS') || alg === 'dir' || alg.startsWith('PBES2') || /^A\d{3}(?:GCM)?KW$/.test(alg);
  if (symmetric) {
    symmetricTypeCheck(alg, key);
  } else {
    asymmetricTypeCheck(alg, key, usage);
  }
};
export default checkKeyType;